export default {
    RECEPCAO: 1,
    TRIAGEM: 2,
    CONSULTORIO: 3,
    ENFERMAGEM: 4,
    EXAMES: 5,
    ADMINISTRACAO: 6,
    ALMOXARIFADO: 7,
    LIMPEZA: 8,
    TRANSPORTE: 9,
    OBSERVACAO: 10,
    FARMACIA: 11,
}